<template>
  <div class="panel">
    <div class="panel-header">
      <slot name="header"></slot>
      <div>
        <slot name="action_buttons"></slot>
      </div>
    </div>
    <div class="panel-body">
      <slot></slot>
    </div>
    <div class="panel-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>
